"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lazyLoader_1 = __importDefault(require("./lazyLoader"));
var collectionGrid_1 = __importDefault(require("../modules/collectionGrid"));
var Advertisements = /** @class */ (function () {
    function Advertisements() {
        this.config = {
            currentPage: 1
        };
        this.sortedAdvertisements = null;
    }
    Advertisements.prototype.init = function (advertisements, currentPage) {
        this.load(advertisements, currentPage);
    };
    Advertisements.prototype.load = function (advertisements, currentPage) {
        if (advertisements) {
            this.sortedAdvertisements = this.sort(this.reduce(advertisements));
            this.update(currentPage);
        }
    };
    Advertisements.prototype.reduce = function (advertisements) {
        var _this = this;
        return Object.keys(advertisements).reduce(function (acc, key, index) {
            advertisements[key].forEach(function (value, index) {
                acc[index] = acc[index] || _this.createEmptyAdvertisement();
                if (key == 'position')
                    value = parseInt(value);
                acc[index][key] = value || null;
            });
            return acc;
        }, []);
    };
    Advertisements.prototype.createEmptyAdvertisement = function () {
        return {
            btn_text: null,
            btn_url: null,
            position: null,
            img_mobile: null,
            img_desktop: null,
            heading: null,
            currentPage: 1,
        };
    };
    Advertisements.prototype.sort = function (reducedAdvertisements) {
        return reducedAdvertisements.sort(function (a, b) { return (a.position > b.position) ? 1 : -1; });
    };
    Advertisements.prototype.update = function (currentPage) {
        var _this = this;
        this.sortedAdvertisements.filter(function (advertisement) {
            return advertisement.position <= collectionGrid_1.default.config.productsPerPage * currentPage;
        }).forEach(function (advertisement) {
            var collectionTiles = document.querySelectorAll('[data-product-tile], [data-advertisement]');
            _this.render(advertisement, collectionTiles);
            _this.sortedAdvertisements.shift();
            _this.config.currentPage++;
            lazyLoader_1.default.update();
        });
    };
    Advertisements.prototype.render = function (advertisement, collectionTiles) {
        var imgMobileSrc = advertisement.img_mobile ? advertisement.img_mobile[0].src : null;
        var imgDesktopSrc = advertisement.img_desktop ? advertisement.img_desktop[0].src : null;
        var collectionTile = collectionTiles[advertisement.position - 1];
        if (collectionTile && imgMobileSrc && imgDesktopSrc) {
            collectionTile.insertAdjacentHTML('beforebegin', "\n        <div class=\"hero hero--advertisement\" data-advertisement>\n          <div class=\"hero__imgs\">\n            <div class=\"hide--sm\">\n              <img class=\"img lazy\" data-src=\"".concat(imgDesktopSrc, "\">\n            </div>\n            <div class=\"hide--md-up\">\n              <img class=\"img lazy\" data-src=\"").concat(imgMobileSrc, "\">\n            </div>\n          </div>\n          <div class=\"hero__bottom\">\n            <div class=\"cta cta--invert\">\n              <h2 class=\"cta__heading cta__heading--h2\">\n                ").concat(advertisement.heading, "\n              </h2>\n              <div class=\"cta__btns\">\n                <a class=\"btn btn--invert btn--squeeze\" href=\"").concat(advertisement.btn_url, "\">\n                  ").concat(advertisement.btn_text, "\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      "));
        }
    };
    return Advertisements;
}());
exports.default = new Advertisements();
